import { OnInit, Component, Inject, Optional } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NxiContextUtils } from '@pershing/nxi-common';
import { DomainContext } from '@pershing/pershing-core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'margin-journal-link',
    templateUrl: './Margin-journal-component.html'
})

export class MarginJournalComponent implements OnInit {
    url: string;
    target: string;
    acctRef: any;
    showMarginJournalLink: boolean = false;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private location: Location,
                private translationService: PershingTranslationService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private route: ActivatedRoute,
                @Optional() @Inject('AppSettings') appSettings: any,
                private sanitizer: DomSanitizer) {
                    this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
                    if (appSettings.marginJournalUrl) {
                        this.url = appSettings.marginJournalUrl;
                    }
    }

    ngOnInit() {
        // Call the wiget params service to get the valid args
    this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            // this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.nxiWidgetParamsService.getWidgetParams( this.acctRef , 'marginJournal').subscribe(
            resp => {
                if (resp.response) {
                    this.showMarginJournalLink = !resp.response.account.group && resp.response.marginJournalEnabled;
                }
            }
          );
    });
    this.target = '_blank';
    }

     async changeGetToPost() {
        let  paramstring, parameters;
        let url = this.url, Hashparameters = '', HashParamValue = '';
        paramstring = url.substring(0, url.length);
        parameters = paramstring.split('\?');
        if (parameters && parameters.length > 2) {
            for (let i = 2; i < parameters.length; i++) {
                parameters[1] = parameters[1] + '&' + parameters[i];
            }
        }
        if (parameters.length > 1) {
            Hashparameters = parameters[1].split('\#');
        }
        if (Hashparameters.length > 1) {
           HashParamValue = Hashparameters[1];
           parameters[0] = parameters[0] + '#' + HashParamValue;
           let parameterlength = parameters[1].indexOf('#');
           parameters[1] = parameters[1].substring(0, parameterlength);
        }
        let submitForm = this.getNewSubmitForm(this.target, parameters[0]);
        if (parameters.length > 1) {
            let queryparams = parameters[1].split('\&');
            for (let indexlet = 0; indexlet < queryparams.length; indexlet++) {
                let param = queryparams[indexlet];
                let namelen = param.indexOf('=');
                let paramname = param.substring(0, namelen);
                let paramvalue = param.substring(namelen + 1, param.length);
                if (paramvalue.indexOf('+') !==  -1) {
                    paramvalue = paramvalue.replace(/\+/g, ' ');
                }
                this.createNewFormElement(submitForm, paramname, paramvalue);
            }
        }
        submitForm.submit();
    }

    getFormSubmit(){
        let getSubmitForm = this.getNewSubmitForm(this.target,this.url);
        getSubmitForm.submit();   
    }

    getNewSubmitForm(targetName: string, actionurl: string) {
        let submitForm = document.createElement('form');
        document.body.appendChild(submitForm);
        submitForm.action = actionurl;
        if (targetName) {
            submitForm.target = targetName;
        }
        submitForm.method = 'get';
        return submitForm;
    }

    createNewFormElement(inputForm: any, elementName: any, elementValue: any): any {
            let newElement = document.createElement('input');
            newElement.type = 'hidden';
            newElement.name =  elementName;
            inputForm.appendChild(newElement);
            newElement.value = JSON.stringify(elementValue);
            return newElement;
    }
}
